import IMessage from "./IMessage";

export default class Message implements IMessage {
    public content: string = null;
    public user: string = null;
    public userLinkName: string = null;
    public timestamp: number = null;
    public room: string = null;

    constructor(content: string, user: string, userLinkName: string, timestamp: number, room: string) {
        this.content = content;
        this.user = user;
        this.userLinkName = userLinkName ? userLinkName : '';
        this.timestamp = timestamp;
        this.room = room;
    }

}